import { FormikProps } from "formik";
import {
  EquipmentItemViewModel,
  ItemViewModel,
  SubmitBlankMediaProfessionalUserApplication,
} from "../../../../../../generated/data-contracts";
import { AvisLoader } from "../../../../../shared/components";
import { BlankMediaApplicationEquipApplications } from "./EquipApplications";

interface IApplicationSectionsProps {
  bag: FormikProps<SubmitBlankMediaProfessionalUserApplication>;
  equipments: EquipmentItemViewModel[] | undefined;
  importersAndManufacturers: ItemViewModel[] | undefined;
  disabled: boolean | undefined;
  loading: boolean | undefined;
}
export function ApplicationSections(
  props: Readonly<IApplicationSectionsProps>,
) {
  const { bag, equipments, importersAndManufacturers, disabled, loading } =
    props;

  if (!equipments || !importersAndManufacturers) return <AvisLoader inline />;

  if (bag.values.dealNotOccuredPortal) return;

  return (
    <div className="blank-media-professional-user-application-sections">
      <BlankMediaApplicationEquipApplications
        bag={bag}
        bagField="equipApplications"
        equipments={equipments}
        importersAndManufacturers={importersAndManufacturers}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
}
